import { Component, OnInit } from '@angular/core';
import { HttpClient, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import {debounceTime} from 'rxjs/operators';
import {Subject} from '../../../node_modules/rxjs';
import {Router} from '@angular/router';
import {ReferenceTableService} from '../reference-table.service';

import {WpMessages} from '../shared/model/WpMessages';
import {DashboardSearch} from '../shared/model/dashboardSearch.model';
import {
  Appointment,
  CommonUtility,
  DataService,
  DateUtility,
  ServerConstantsService,
  Task,
  TimeUtility,
  WpEtEnrollment
} from '../shared';
import { NotificationsService } from 'angular2-notifications';
import * as moment from 'moment';
import * as $ from 'jquery';
import 'jquery-ui/ui/widgets/draggable.js';
import {DashboardType} from "../shared/model/dashboardType";
import {ProviderDashboardSearch} from "../shared/model/ProviderDashboardSearch";
import {TaskChart} from "../shared/model/TaskChart";

const OPEN = 'OP';
const IN_PROGRESS = 'IP';
const SCHEDULE = 'SH';
const RESCHEDULE = 'RS';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {

  selectCountyDashboard: boolean;
  selectProvidedDashboard: boolean;
  sharedData: any;
  roles: any;
  providerId: any;

  taskStatus: any[];
  taskType: any[];
  appointmentType: any[];

  ServerConstants: any;
  userActionNotificationsMap: any;

  constructor(
    private http: HttpClient,
    private dataService: DataService,
    private router: Router,
    private data: ReferenceTableService,
    private commonUtil: CommonUtility,
    private timeUtil: TimeUtility,
    private notificationService: NotificationsService,
    private serverConstantsService: ServerConstantsService,
    private dateUtil: DateUtility
  ) {
    this.ServerConstants = serverConstantsService.getConstants();
  }

  ngOnInit() {
     /* Making draggable chatbot in app-component.
     * This call was made here due to after login, the route is re-directing to dashboard,
     * and app-component ngOnInit is not called, so the chatbot is not initialized, and
     * will not work until a refresh in the page. In order to fix that refresh, this call
     * was invoked here.
     * **this should be refactored with @Output or something else to be able invoking a
     * function from child to parent
     */
    this.chatbotDraggable();
    this.selectCountyDashboard = false;
    this.selectProvidedDashboard = false;

    this.userActionNotificationsMap = this.commonUtil.createNativeMapFromList(this.data.getValueFromSharedDataMap('USER-ACTION-NOTIFICATIONS'));

    this.sharedData = this.dataService.getSharedDataObject();

    this.http.get<DashboardType>( this.ServerConstants.SERVER_API_URL + '/dashboard/select' ).subscribe(
      (data) => {
        if(data.hasOwnProperty('errorCode')){

        }
        else{
          if(data.dashboardType == "P"){
            this.router.navigate(['dashboard/provider']);
          }
          else{
            this.router.navigate(['dashboard/worker']);
          }
        }
      },response => {

      },() => {

      });
    //At this point I am not getting anything from ShareData
    //this.userAccess();
  }

  sleep(milliseconds) {
    var start = new Date().getTime();
    for (var i = 0; i < 1e7; i++) {
      if ((new Date().getTime() - start) > milliseconds){
        break;
      }
    }
  }

  userAccess(){
    /*
    * Provider Dashboard read and not write for role Provider (5)
    * */
    this.roles = this.sharedData.get('roles');
    let isProvider = false;
    if(this.roles != undefined ){
      for( const role of this.roles){
        if( role.id === 5  ){
          this.router.navigate(['dashboard/provider']);
          isProvider = true;
          break;
        }
      }
      if(isProvider === false){
        this.router.navigate(['dashboard/worker']);
      }
    }
  }


  /**
   * Added drag & drop event to the chatbot sticky button & chatbot window
   */
  chatbotDraggable(){
    $( function() {
        // Add drag & drop event to the Chatbot window
        ($( "#chatbotMainContainer") as any).draggable();

        // Add drag & drop event to the Chatbot sticky button
        ($('#chatbotMainContainerBtn') as any).draggable();

        /* Add click event event to the Chatbot sticky button
          * - 1. added drag & drop, to immediately stop click propagation
          * - 2. added click event, so the element can be listening for single click
          */
        $('#chatbotMainContainerBtn').click(() => {
            $("#chatbotMainContainer").show();
            $('#chatbotMainContainerBtn').hide();
        });
    } );
  }

}



// WEBPACK FOOTER //
// ./src/app/dashboard/dashboard.component.ts